// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-smallOnConfined-text-844cb513"};